import type { SessionLiveViewGateway, SessionLiveViewSnapshot } from "./types";

/**
 * Demo snapshot matching the admin Live View mock.
 * Replace this gateway with a session-service implementation; callers keep the same methods.
 * The clock is fixed so "Started 4 min ago" stays stable.
 */
const AS_OF = "2026-10-27T15:04:00+05:30";
const WINDOW_START = "2026-10-27T15:00:00+05:30";
const WINDOW_END = "2026-10-27T16:00:00+05:30";

function createInitialSnapshot(): SessionLiveViewSnapshot {
  return {
    asOf: AS_OF,
    timeZone: "Asia/Kolkata",
    scheduledToday: 42,
    completed: 18,
    upcomingToday: 18,
    bothJoined: 3,
    studentMissing: 1,
    neitherJoined: 0,
    tutorMissingSessions: [
      {
        id: "session-aarav",
        studentName: "Aarav S.",
        initials: "AS",
        gradeSubjectLabel: "grade 8 math",
        startedAt: WINDOW_START,
        windowStart: WINDOW_START,
        windowEnd: WINDOW_END,
        studentJoinedAt: "2026-10-27T15:01:00+05:30",
        approvalLabel: "Approved grade 8 math",
        assignedTutorId: null,
        substitutes: [
          {
            id: "tutor-riya",
            name: "Riya Sharma",
            initials: "RS",
            gradeSubjectMatch: "Grade 8 math",
            freeUntil: "2026-10-27T17:30:00+05:30",
          },
          {
            id: "tutor-nikhil",
            name: "Nikhil Patra",
            initials: "NP",
            gradeSubjectMatch: "Grade 8 math",
            freeUntil: WINDOW_END,
          },
        ],
      },
      {
        id: "session-meher",
        studentName: "Meher K.",
        initials: "MK",
        gradeSubjectLabel: "grade 10 CCSS algebra",
        startedAt: "2026-10-27T14:55:00+05:30",
        windowStart: WINDOW_START,
        windowEnd: WINDOW_END,
        studentJoinedAt: WINDOW_START,
        approvalLabel: "Approved grade 10 CCSS algebra",
        assignedTutorId: null,
        substitutes: [
          {
            id: "tutor-anika",
            name: "Anika Rao",
            initials: "AR",
            gradeSubjectMatch: "Grade 10 algebra",
            freeUntil: "2026-10-27T17:00:00+05:30",
          },
          {
            id: "tutor-dev",
            name: "Dev Shah",
            initials: "DS",
            gradeSubjectMatch: "Grade 10 algebra",
            freeUntil: WINDOW_END,
          },
        ],
      },
    ],
  };
}

function cloneSnapshot(snapshot: SessionLiveViewSnapshot): SessionLiveViewSnapshot {
  return structuredClone(snapshot);
}

export function createDemoSessionLiveView(): SessionLiveViewGateway {
  let snapshot = createInitialSnapshot();

  return {
    async fetchSnapshot() {
      return cloneSnapshot(snapshot);
    },
    async assignSubstitute(sessionId, tutorId) {
      const session = snapshot.tutorMissingSessions.find((item) => item.id === sessionId);
      if (!session) {
        throw new Error("That session is no longer waiting on a tutor.");
      }
      const tutor = session.substitutes.find((item) => item.id === tutorId);
      if (!tutor) {
        throw new Error("That tutor is not free for the remaining window.");
      }
      snapshot = {
        ...snapshot,
        tutorMissingSessions: snapshot.tutorMissingSessions.map((item) =>
          item.id === sessionId ? { ...item, assignedTutorId: tutorId } : item
        ),
      };
      return cloneSnapshot(snapshot);
    },
  };
}

export const demoSessionLiveView = createDemoSessionLiveView();
